import './global.css';
import React, { useEffect, useLayoutEffect } from "react";
import { GatsbyBrowser } from 'gatsby';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  window.addEventListener('error', (errorEvent: ErrorEvent) => {
    // ここでエラー情報をログに記録したり、GTMに送信したりします
    console.error("Error caught:", errorEvent);

    saveErrorToLocalStorage(errorEvent.error.stack);
  });
};

const saveErrorToLocalStorage = (error: any) => {
   // エラー情報をJSON文字列に変換してlocalStorageに保存
   const errorString = JSON.stringify(error);
   localStorage.setItem('error', errorString);
};

// 全体のエラーをキャッチ
class ErrorBoundary extends React.Component {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught:", error, errorInfo);

    // エラー情報をlocalStorageに保存
    saveErrorToLocalStorage(error);
  }

  render() {
    return this.props.children;
  }
}

const WrappedErrorBoundary: React.FC = ({ children }) => {
  useEffect(() => {
    // useEffect内でのエラーをキャッチ
    const errorEventHandler = (event: PromiseRejectionEvent) => {
      console.error("Error caught in useEffect:", event.reason);

      // エラー情報をlocalStorageに保存
      saveErrorToLocalStorage(event.reason);
    };

    window.addEventListener("unhandledrejection", errorEventHandler);

    return () => {
      window.removeEventListener("unhandledrejection", errorEventHandler);
    };
  }, []);

  useLayoutEffect(() => {
    // useLayoutEffect内でのエラーをキャッチ
    const errorEventHandler = (event: PromiseRejectionEvent) => {
      console.error("Error caught in useLayoutEffect:", event.reason);

      // エラー情報をlocalStorageに保存
      saveErrorToLocalStorage(event.reason);
    };

    window.addEventListener("unhandledrejection", errorEventHandler);

    return () => {
      window.removeEventListener("unhandledrejection", errorEventHandler);
    };
  }, []);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

// 全ページに適応
export const wrapRootElement = ({ element }) => {
  return <WrappedErrorBoundary>{element}</WrappedErrorBoundary>;
};
